import React from "react";
import { Container, Box, Typography, Grid } from "@mui/material";
import SectionHeading from "./SectionHeading";
import { colors, fonts, ui } from "../theme";

const milestones = [
  {
    year: "2026",
    title: "Partnership Expansion & Baseline Sync",
    text: "Expanding institutional partnerships across Tamil Nadu, aligning course frameworks with current tech and rolling out milestone-driven internships.",
  },
  {
    year: "2027",
    title: "Research Scholar Initiatives",
    text: "Advanced tracks for faculty and PG scholars — deep research methodologies, structured patent applications and peer-reviewed papers.",
  },
  {
    year: "2028",
    title: "On-Campus Innovation Labs",
    text: "Co-establishing dedicated Innovation Labs with cloud frameworks and testing tools for real-world industrial challenges.",
  },
  {
    year: "2029",
    title: "Collaborative Research Ecosystem",
    text: "An interconnected network of industry partners, research institutions and experts to drive collaborative projects and secure funding.",
  },
  {
    year: "2030",
    title: "ARICE — Centre of Excellence",
    text: "Establishing a premier regional Academic Research & Innovation Centre of Excellence driving national recognition and top-tier placements.",
  },
];

const Roadmap = () => {
  return (
    <section id="roadmap-section" className="roadmap-section">
      <Box sx={{ background: colors.bgGradient, py: { xs: 5, md: 7 } }}>
        <Container>
          <SectionHeading
            eyebrow="Strategic Roadmap 2026–2030"
            title="A Long-Term Plan to Become a Regional Hub of Excellence"
            subtitle="A phased evolution that grows partner institutions into recognised centres for technical excellence, innovation and original research."
          />
          <Grid container spacing={2.5}>
            {milestones.map((m, i) => (
              <Grid item xs={12} key={m.year}>
                <Box sx={{ display: "flex", gap: { xs: 2, md: 3 } }}>
                  {/* Year + line */}
                  <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", minWidth: { xs: 64, md: 96 } }}>
                    <Box
                      sx={{
                        background: colors.brandGradient,
                        color: colors.white,
                        fontFamily: fonts.heading,
                        fontWeight: 800,
                        borderRadius: "999px",
                        px: { xs: 1.5, md: 2 },
                        py: 0.8,
                        fontSize: { xs: "0.9rem", md: "1rem" },
                      }}
                    >
                      {m.year}
                    </Box>
                    {i < milestones.length - 1 && (
                      <Box sx={{ flexGrow: 1, width: 2, bgcolor: "#d3deee", mt: 1 }} />
                    )}
                  </Box>
                  {/* Content */}
                  <Box
                    sx={{
                      ...ui.cardHover,
                      bgcolor: colors.white,
                      border: "1px solid #e6edf7",
                      borderRadius: 3,
                      p: 2.75,
                      mb: 1.5,
                      flexGrow: 1,
                    }}
                  >
                    <Typography sx={{ fontFamily: fonts.heading, fontWeight: 700, color: colors.navy, mb: 0.6 }}>
                      {m.title}
                    </Typography>
                    <Typography sx={{ color: colors.textMuted, fontSize: "0.92rem", lineHeight: 1.65 }}>
                      {m.text}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </section>
  );
};

export default Roadmap;
